import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#FBE9B1"
      d="M16.475 10.55a6 6 0 0 0-11.388 3.487 6.14 6.14 0 0 0 1.363 2.888A5.45 5.45 0 0 1 9.5 16a5.3 5.3 0 0 1 1.787.3 8.54 8.54 0 0 1 5.188-5.75"
    />
    <path
      fill="#E2BA2B"
      d="M9.263 3.153a1 1 0 0 1 1.16.81L10.784 6a7 7 0 0 1 3.37.75l1.19-1.699A1 1 0 0 1 16.982 6.2l-1.19 1.698a7 7 0 0 1 1.596 2.245 1 1 0 0 1-1.826.816 5 5 0 0 0-1.624-2.005 1 1 0 0 1-.144-.1 5 5 0 0 0-6.82 1.174 1 1 0 0 1-.146.209q-.05.073-.095.149a5 5 0 0 0-.654 3.519 5.14 5.14 0 0 0 1.133 2.374 1 1 0 1 1-1.524 1.294 7.1 7.1 0 0 1-1.34-2.387l-2.035.362a1 1 0 1 1-.35-1.97L4 13.216a7 7 0 0 1 .746-3.371L3.051 8.656A1 1 0 0 1 4.2 7.018l1.694 1.187a7 7 0 0 1 2.921-1.86l-.36-2.033a1 1 0 0 1 .809-1.16"
    />
    <path
      fill="#CEEDFF"
      d="M11 18.5a8.5 8.5 0 1 1 8.5 8.5h-10a5.499 5.499 0 0 1-3.889-9.39 5.5 5.5 0 0 1 5.677-1.31"
    />
    <path
      fill="#80C4FF"
      d="M15.864 9.723A9.5 9.5 0 1 1 19.5 28h-10A6.5 6.5 0 0 1 3 21.5 6.5 6.5 0 0 1 9.495 15q.466-.002.925.063l.209.035.007-.015q.314-.815.776-1.565l.19-.296a9.5 9.5 0 0 1 4.262-3.499m5.099 1.421A7.5 7.5 0 0 0 12 18.5a1 1 0 0 1-2 0q0-.706.103-1.398l.01-.062-.019-.003a4 4 0 0 0-.296-.028l-.298-.01a4.5 4.5 0 1 0 0 9h10a7.5 7.5 0 0 0 6.929-4.629 7.5 7.5 0 0 0-1.626-8.174 7.5 7.5 0 0 0-3.84-2.052"
    />
  </svg>
);
const SvgIconWeatherCloudSun = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloudSun);
export default Memo;
